import {IDirective} from "angular";

export const InputScrollBlock = "tfInputScrollBlock";

export function inputScrollBlock(): IDirective {
    return  {
        restrict: "A",
        link: ($scope, $element, $attr) => {

            let block = false;

            $element.on("focus", () => block = true);
            $element.on("blur", () => block = false);

            $element.on("wheel", (event) => event.preventDefault());
        }
    };
}
